import React from 'react';
import './doorCards.scss';

export default function DoorCards() {

  return (
    <>
      <div className="">
      <ul className="door-cards-grid" >
            
              <li className="door-deck-draw">Door Draw Deck</li>
              <li className="door-deck-discard">Door Discard Deck</li>
          </ul> 
      </div>
    </>
  );
}


